/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get */
import Controller from '@ember/controller';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { tracked } from '@glimmer/tracking';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import { byKeys, mapBy } from '@linc-technologies/linced-common/utils/arrays';

export default class StaffController extends Controller {
  @service
  toaster;

  @service
  schoolSchema;

  PersonType = PersonType;
  @tracked
  dialogOpen = false;
  @tracked
  person = null;
  conflictedEmailAddress = '';

  @computed('model.{staff.[],users.@each.disabled}')
  get currentStaff() {
    let userIds = mapBy(
      this.model.users.filter((item) => !item.disabled),
      'id',
    );
    return this.model.staff
      .filter((person) => {
        return userIds.includes(person.userId);
      })
      .sort(byKeys('firstName', 'lastName'));
  }

  @computed('model.{staff.[],users.@each.disabled}')
  get formerStaff() {
    let userIds = mapBy(
      this.model.users.filter((item) => item.disabled === true),
      'id',
    );
    return this.model.staff
      .filter((person) => {
        return isEmpty(person.userId) || userIds.includes(person.userId);
      })
      .sort(byKeys('firstName', 'lastName'));
  }

  @action
  addStaffMember() {
    this.person = this.schoolSchema.newPerson(PersonType.STAFF);
    this.dialogOpen = true;
  }

  @action
  editStaffMember(person) {
    this.person = person;
    this.dialogOpen = true;
  }

  @action
  onSave() {
    this.dialogOpen = false;
    this.toaster.success(
      `Staff member "${this.get('person.fullName')}" was saved successfully.`,
    );

    this.get('model.staff').update();
    this.get('model.users').update();
  }

  @action
  closeDialog() {
    this.dialogOpen = false;
  }
}
